export const actionOptions = {
  "all": [
    {
      title: "Upload Documents",
      cls: "bulk-upload-documents",
      icon: "upload",
      disabled:true
    }
  ],
  "actions": [
    {
      icon: "upload",
      title: "Upload Documents",
      cls: "upload-documents",
      disabled:false
    },
    {
      icon: "download",
      title: "Download Documents",
      cls: "download-documents",
      disabled:false
    }
  ]
};



// WEBPACK FOOTER //
// ./src/pages/proofOfDelivery/podShipmentSummary/filter/actionOptions.js